<div class="datetime-picker-fields">
  <mat-form-field class="timepicker-container" color="primary" appearance="outline">
    <mat-label>Datum</mat-label>
    <input matInput [matDatepicker]="picker" [value]="date" (dateChange)="onDateSelected($event)"
      [disabled]="disabled">
    <mat-datepicker-toggle style="color: #2196f3" matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>

  <mat-form-field class="timepicker-container" color="primary" appearance="outline">
    <mat-label>Uhrzeit</mat-label>
    <input matInput type="time" step="300" [value]="timeString"
      (change)="onTimeChanged($any($event.target).value)" [disabled]="disabled">
  </mat-form-field>
</div>

@if (showClearButton && !disabled) {
  <div class="clear-button-container">
    <button color="primary" class="clear-button" (click)="clear()" [disabled]="layoutElemeneUtil.ReadonlyMode" mat-stroked-button>
      <mat-icon color="accent" class="clear-icon" matPrefix>clear_all</mat-icon>
      Datum löschen
    </button>
  </div>
}
